<template>
  <div class="admin" v-if="$store.state.user.logged_in == 1">
    <div id="user">
    <ul>
        <li><button v-on:click="logout">Logout</button></li>
    </ul>
    </div>
    <div id="lebenslauf">

      <div class="left">
        <div class="header">
        <p>JÖRG HÄFNER</p>
        <p>Softwareentwickler</p>
        <img src="static/img/profilbild.png" />
        </div>

        <div class="persoenliches">
          <p class="head">PERSÖNLICHES</p>
          <table>
            <tr><td><font-icon icon="map-marker-alt"/></td><td>GEB. 14.06.1982<br />IN FORCHHEIM</td></tr>
            <tr><td><font-icon icon="home"/></td><td>HAUPTSTR. 34b<br />91083 BAIERSDORF</td></tr>
            <tr><td><font-icon icon="envelope"/></td><td>INFO@J-HAEFNER.DE</td></tr>
            <tr><td><font-icon icon="phone-square"/></td><td>+49 160 157 2826</td></tr>
            <tr><td><font-icon icon="globe"/></td><td>WEBDESIGN-HAEFNER.DE</td></tr>
          </table>
        </div>

        <div class="kenntnisse">
          <p class="head">KENNTNISSE</p>
          <table>
            
            <tr><td>SQL / T-SQL</td><td><Rating :howmany="4"/></td></tr>
            <tr class="distance"><td>MySQL / MariaDB</td><td><Rating :howmany="4"/></td></tr>

            <tr><td>PERL</td><td><Rating :howmany="5"/></td></tr>
            <tr><td>C# / .NET / ASPX</td><td><Rating :howmany="4"/></td></tr>
            <tr><td>LINUX</td><td><Rating :howmany="3"/></td></tr>
            <tr class="distance"><td>WEBSERVICES</td><td><Rating :howmany="3"/></td></tr>

            <tr><td>HTML5 / CSS3</td><td><Rating :howmany="5"/></td></tr>
            <tr><td>JAVASCRIPT</td><td><Rating :howmany="4"/></td></tr>
            <tr><td>NPM / Vue.js</td><td><Rating :howmany="3"/></td></tr>
            <tr><td>Node.js</td><td><Rating :howmany="3"/></td></tr>
            <tr><td>APACHE Server</td><td><Rating :howmany="4"/></td></tr>
            <tr><td>IIS Server</td><td><Rating :howmany="4"/></td></tr>
          </table>
        </div>

        <div class="kenntnisse">
          <p class="head">SPRACHEN</p>
          <table>
            
            <tr><td>DEUTSCH</td><td><Rating :howmany="5"/></td></tr>
            <tr><td>ENGLISCH</td><td><Rating :howmany="2"/></td></tr>
          </table>
        </div>
      </div>

      <div class="right">
        <div class="cut">
          <p class="head">BERUFSERFAHRUNG</p>
          <div class="line">
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Softwareentwickler</p>
              <div class="col"><div class="ort">Siemens AG, Fürth</div><div class="time">09/2016 - heute</div></div>
              <p class="desc">bla bla bla</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Anwenderbetreuer</p>
              <div class="col"><div class="ort">Siemens AG, Fürth</div><div class="time">08/2011 - 09/2016</div></div>
              <p class="desc">bla bla bla</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Prüffeldspezialist</p>
              <div class="col"><div class="ort">Siemens AG, Fürth</div><div class="time">10/2001 - 08/2011</div></div>
              <p class="desc">bla bla bla</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Prüfer</p>
              <div class="col"><div class="ort">Siemens AG, Karlsruhe</div><div class="time">06/2001 - 10/2001</div></div>
              <p class="desc">bla bla bla</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Prüfer</p>
              <div class="col"><div class="ort">Siemens AG, Fürth</div><div class="time">02/2001 - 06/2001</div></div>
              <p class="desc">bla bla bla</p>
            </div>
          </div>
        </div>
        <div class="cut">
          <p class="head bildung">BILDUNGSWEG</p>
          <div class="line">
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Staatlich geprüfter Techniker in Informatik</p>
              <div class="col"><div class="ort">Technikerschule, Erlangen</div><div class="time">09/2007 - 07/2011</div></div>
              <p class="desc">Abschlussnote: 2,4<br />Fachhochschulreife: 3,0</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Energieelektroniker - Fachrichtung Anlagentechnik</p>
              <div class="col"><div class="ort">Berufsschule Fürth</div><div class="time">09/1997 - 02/2001</div></div>
              <p class="desc">Zusätzlicher Abschluss: mittlere Reife</p>
            </div>
            <div class="item">
              <p class="title"><font-icon :icon="['fa', 'circle']"/>Qualifizierender Hauptschulabschluss</p>
              <div class="col"><div class="ort">Hauptschule Kirchehrenbach</div><div class="time">09/1994 - 07/1997</div></div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <router-view></router-view>
  </div>
</template>
<script>

import Rating from "./../components/Rating";
export default {
  name: 'lebenslauf',
  data () {
    return {
      test: { }
    }
  },
  mounted: function () {
    this.$http.get('/api/checklogin.pl').then(function (response) {
      this.$store.state.user = response.data.user
      console.log(this.$store.state.user)
      if( this.$store.state.user.logged_in == 0 ){
        this.$router.push({ name: 'login' }) 
      }
    });
  },
  methods: {
    logout: function (event) {
      this.$http.get('/api/logout.pl').then(function (response) {
        this.$store.state.user = response.data.user
        if( this.$store.state.user.logged_in == 0 ){
          this.$router.push({ name: 'login' }) 
        }
      });  
    }
  },
  components: {
    Rating
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cut .line {
  border-left: 1px solid #c2c2c2;
  padding-left: 10px; 
}
.item .title {
  position: relative;
  font-size: 1rem;
  font-weight: bold;
  color: #35495E;
  margin: 24px 0 6px;
}
.item:first-child .title{
  margin-top: 0;
}
.line .title .fa-circle{
  position: absolute;
  left: -17px;
  top: 2px;
  font-size: 0.8rem;
  color: #8996aa;
}
.line .col .ort, .line .col .time{
  font-weight: bold;
  font-style: italic;
}
.line .desc{
  margin: 5px 0 0;
}

.line .col {
  display: flex;
  justify-content: space-between;
}

#lebenslauf{
  height:297mm;
  width:210mm;
  margin: 10px auto;
  background-color: #fff;
  padding: 10px 15px;
  position: relative;
  border: 1px solid #e6e6e6;
  box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
}
.left {
  width: 40%;
  float: left;
}
.right{
  margin-left: 45%;
}

.header {
  text-align: center;
  
}
.header p:nth-child(1){
  font-weight: bold;
  letter-spacing: 0.8px;
  font-size: 1.4em;
  margin: 10px 0 2px;
} 
.header p:nth-child(2){
  color: #8996aa;
  font-size: 1.3em;
  font-style: italic;
  margin: 0 0 7px;
} 

.header p{
  text-align: center;

}

p.head{
  border-top: 1px solid #c2c2c2;
  border-bottom: 1px solid #c2c2c2;
  margin: 10px 0;
  padding: 10px 0;
  width: 100%;
  letter-spacing: 0.8px;
  font-weight: bold;
  font-size: 1.1em;
  color: #666666;
}

p.head.bildung {
  margin-top: 24px;
}

.header img {
  width: 55%;
}
.persoenliches p, .kenntnisse p{
  margin: 8px 0 3px;  
}
.persoenliches table {
  width: 100%;
  border-spacing: 3px 10px;
}

.persoenliches table tr td:nth-child(1){
  width: 75px;
  font-size: 1.5rem;
  text-align: center;
  padding-right: 10px;
  border-right: 1px solid #c2c2c2;
  color: #666666;
}
.persoenliches table tr td:nth-child(2){
  text-align: right;
  font-size: 0.9rem;
  color: #666666;
}

.kenntnisse table {
  width: 100%;
  border-spacing: 3px 15px;
}

.kenntnisse table tr td:nth-child(1){
  width: 190px;
  font-size: 0.8rem;
}

.kenntnisse table tr td:nth-child(2){
  font-size: 0.8rem;
  text-align: right;
}

.kenntnisse table tr.distance td{
  padding-bottom: 10px;
}


#user {
  position: absolute;
  top: 20px;
  left: 20px;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}

@media print {
  @page { margin: 0; } 
  body * {
    visibility: hidden;
  }
  #lebenslauf, #lebenslauf * {
    visibility: visible;

  }
  #lebenslauf {
    margin: 0;
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    box-shadow: none;
  }
  .kenntnisse table{
    font-size: 0.8rem;
  }
  .persoenliches p, .kenntnisse p{
    margin: 0;
  }
  .header img {
  width: 50%;
}
}
</style>



// WEBPACK FOOTER //
// src/admin/Lebenslauf.vue